var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlutenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 612 792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c1924d;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.5,43.6c-19.5,17.7-38.5,48.4-47.1,77-6.1,19.9-7.8,57.9-3,80.9,4.3,21.2,12.5,41.1,25.1,60.1,9.9,15.1,30.3,37.6,34.2,37.6s22.9-20.8,31.1-33.7c22.1-32.4,30.7-59.7,30.7-98.6s-16.4-84.3-48.9-118.5l-13-13.4-9.1,8.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.7,242.5c-2.6.4-8.6,1.3-13.4,2.2-10.4,1.3-11.7,4.8-8.6,30.7,5.2,47.6,28.1,84.3,67.9,111.1,26.4,17.7,54,29.8,87.8,38.5,26.8,6.9,25.1,8.2,23.3-21.6-2.2-42.8-12.1-78.3-28.1-102.9-16.9-25.1-48.4-46.7-79.1-54-13.8-3-41.5-5.2-49.7-3.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M437.1,243.4c-29,3.5-56.6,16-77,35-29.4,27.2-44.5,67-47.6,125-1.3,29.8-3,28.5,23.3,21.6,33.3-8.6,57.1-19,85.2-37.2,41.9-27.2,65.3-64.9,70.5-112.4,2.6-24.2,1.3-29.4-6.9-30.7-13-2.6-34.6-3-47.6-1.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128,414.2c-8.6,1.3-10.4,7.3-7.8,29,4.8,39.3,16.4,65.7,41.1,90.4,23.8,24.2,57.1,43.7,93.8,55.3,18.2,5.6,41.1,11.2,43.7,9.9,2.2-1.3,1.7-26.8-.4-46.7-3-25.5-9.1-46.7-19-67.4-15.1-31.1-41.5-53.6-77.8-65.3-13-4.3-20.3-5.2-41.9-5.6-14.3-.4-28.5,0-31.6.4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428.1,414.6c-66.6,13.8-104.2,59.7-113.7,136.6-2.2,18.6-3,45.4-1.3,47.1,3.5,3,49.3-10.4,74.8-21.6,22.9-10.4,51.9-31.1,66.6-46.7,15.6-16.4,27.7-39.8,33.7-62.7,4.8-19,6.1-47.6,2.6-51.5-3.9-2.6-49.7-3.9-62.7-1.3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.9,584.1c-14.3,2.2-14.7,3.5-11.2,32,3.5,29.8,13,53.6,28.5,75.2,17.3,22.9,51.5,46.7,87.8,61.8,16,6.5,53.6,16.9,60.5,16.9s2.6-4.3,1.7-25.5c-3-55.8-16.9-95.1-43.7-121.5-30.3-30.7-76.5-45.4-123.7-38.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428.9,585c-73.5,14.7-111.5,67-116.3,159.1-.9,22.1-.9,25.5,1.7,25.5s12.1-2.6,23.3-5.2c38-9.5,71.3-25.5,99-47.6,32.9-26.4,49.7-58.4,54.9-103.8,2.2-18.6.9-25.9-3.9-27.7-6.9-2.6-45.4-3-58.8-.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlutenIcon);
export default __webpack_public_path__ + "static/media/gluten_icon.69584a5d58f98e07a148e23c607536de.svg";
export { ForwardRef as ReactComponent };